__webpack_require__.p = "/kw/en/customer-service/returns-claims/spareparts/";